/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../models/amplify/API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getOngoingCalls = /* GraphQL */ `query GetOngoingCalls {
  getOngoingCalls {
    opi {
      callSid
      callId
      pin
      clientNumber
      callStatus
      operators {
        operatorId
        operatorName
        __typename
      }
      outboundPhoneNumbers
      customInputFields {
        name
        value
        isEnabled
        criteriaType
        __typename
      }
      callStartedAt
      durationMilliseconds
      languageName
      __typename
    }
    vri {
      roomSid
      roomStatus
      uniqueName
      callId
      chatSid
      roomCreatedAt
      durationMilliseconds
      participantsUrl
      participants {
        userId
        status
        callParticipantType
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOngoingCallsQueryVariables,
  APITypes.GetOngoingCallsQuery
>;
export const getOngoingCallsPaged = /* GraphQL */ `query GetOngoingCallsPaged(
  $page: Int
  $pageSize: Int
  $filter: OngoingCallFilterInput
  $sortDirection: SortDirection
) {
  getOngoingCallsPaged(
    page: $page
    pageSize: $pageSize
    filter: $filter
    sortDirection: $sortDirection
  ) {
    opi {
      callSid
      callId
      pin
      clientNumber
      callStatus
      operators {
        operatorId
        operatorName
        __typename
      }
      outboundPhoneNumbers
      customInputFields {
        name
        value
        isEnabled
        criteriaType
        __typename
      }
      callStartedAt
      durationMilliseconds
      languageName
      __typename
    }
    vri {
      roomSid
      roomStatus
      uniqueName
      callId
      chatSid
      roomCreatedAt
      durationMilliseconds
      participantsUrl
      participants {
        userId
        status
        callParticipantType
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOngoingCallsPagedQueryVariables,
  APITypes.GetOngoingCallsPagedQuery
>;
